import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appSelectAllOnFocus]",
})
export class SelectAllOnFocusDirective {
  constructor(private readonly elementRef: ElementRef<HTMLInputElement>) {}

  @HostListener("focus")
  onFocus() {
    const el = this.elementRef.nativeElement;
    if (!el || el.type !== "number") {
      return;
    }

    setTimeout(() => {
      const length = el.value?.length ?? 0;
      const originalType = el.type;
      if (originalType === "number") {
        el.type = "text";
      }
      el.setSelectionRange(0, length);
      if (originalType === "number") {
        el.type = originalType;
      }
    }, 0);
  }
}
